import { useCallback } from 'react'
import Particles from 'react-particles'
import { loadSlim } from 'tsparticles-slim'
import { useMaterialUIController } from '../../context'

const ParticlesDiv = () => {
  const [controller] = useMaterialUIController()

  const { theme } = controller
  const particlesInit = useCallback(async engine => {
    await loadSlim(engine)
  }, [])

  if (localStorage.getItem('particles') === '0') {
    return <></>
  }

  const backgroundColor =
    'rgb(' +
    getComputedStyle(document.body).getPropertyValue('--particles-background') +
    ')'

  const darkParticlesColor = '#1b1c1c'
  const lightParticlesColor = '#ffffff'
  const isDarkTheme = theme === 'dark'
  const particlesColor = isDarkTheme ? darkParticlesColor : lightParticlesColor

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      className="!bg-primary"
      options={{
        background: {
          color: {
            value: backgroundColor,
          },
        },
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: 'push',
            },
            onHover: {
              enable: true,
              mode: 'repulse',
            },
            resize: true,
          },
          modes: {
            push: {
              quantity: 0,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: particlesColor,
          },
          links: {
            color: particlesColor,
            distance: 180,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          move: {
            direction: 'none',
            enable: true,
            outModes: {
              default: 'bounce',
            },
            random: false,
            speed: 2,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              area: 800,
            },
            value: 80,
          },
          opacity: {
            value: 0.5,
          },
          shape: {
            type: 'circle',
          },
          size: {
            value: { min: 1, max: 5 },
          },
        },
        detectRetina: true,
      }}
    />
  )
}

export default ParticlesDiv
